import { Box, BoxProps, Typography } from "@mui/material";
import React from "react";
import { CHART_COLORS, CHART_DIMENSIONS, CHART_TYPOGRAPHY } from "./tokens";

interface DataFieldRowProps {
  label: string;
  value?: React.ReactNode;
  stretchValue?: boolean;
  sx?: BoxProps["sx"];
}

const DataFieldRow: React.FC<DataFieldRowProps> = ({
  label,
  value,
  stretchValue = false,
  sx,
}) => {
  const baseFontSx = {
    ...CHART_TYPOGRAPHY.body5,
    fontWeight: CHART_TYPOGRAPHY.weight.regular,
    fontFamily: CHART_TYPOGRAPHY.fontFamily,
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="flex-start" sx={sx}>
      <Typography
        component="span"
        sx={{
          ...baseFontSx,
          color: CHART_COLORS.textLabel,
          textAlign: "right",
          flexShrink: 0,
          width: CHART_DIMENSIONS.labelWidth,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </Typography>

      <Typography
        component="span"
        sx={{
          ...baseFontSx,
          color: CHART_COLORS.textLabel,
          textAlign: "center",
          flexShrink: 0,
          width: CHART_DIMENSIONS.separatorWidth,
          px: "2px",
        }}
      >
        :
      </Typography>

      <Typography
        component="span"
        sx={{
          ...baseFontSx,
          color: CHART_COLORS.textDark,
          textAlign: "left",
          flex: stretchValue ? 1 : "none",
          width: stretchValue ? undefined : CHART_DIMENSIONS.labelWidth,
          wordBreak: "break-word",
        }}
      >
        {value ?? "-"}
      </Typography>
    </Box>
  );
};

export default DataFieldRow;
